// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employeedashboard-inline-1 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 13px;
}

.employeedashboard-inline-2 {
  cursor: pointer;
}

.employeedashboard-inline-3 {
  margin-top: 16px;
}

.employeedashboard-inline-4 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 13px;
}

.employeedashboard-inline-5 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.employeedashboard-inline-6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.employeedashboard-inline-7 {
  font-weight: 600;
  font-size: 13px;
}

.employeedashboard-inline-8 {
  font-size: 11px;
  color: #64748b;
}

.employeedashboard-inline-9 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.employeedashboard-inline-10 {
  margin-top: 16px;
}

.employeedashboard-inline-11 {
  margin-bottom: 10px;
  border: 1px solid #fed7aa;
  background: #fff7ed;
  color: #9a3412;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 700;
}

.employeedashboard-dyn-1 {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--employeedashboard-1-background);
  color: var(--employeedashboard-1-color);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmployeeDashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,uCAAuC;EACvC,gBAAgB;AAClB","sourcesContent":[".employeedashboard-inline-1 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n  font-size: 13px;\n}\n\n.employeedashboard-inline-2 {\n  cursor: pointer;\n}\n\n.employeedashboard-inline-3 {\n  margin-top: 16px;\n}\n\n.employeedashboard-inline-4 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n  font-size: 13px;\n}\n\n.employeedashboard-inline-5 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.employeedashboard-inline-6 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border-radius: 8px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n}\n\n.employeedashboard-inline-7 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.employeedashboard-inline-8 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.employeedashboard-inline-9 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.employeedashboard-inline-10 {\n  margin-top: 16px;\n}\n\n.employeedashboard-inline-11 {\n  margin-bottom: 10px;\n  border: 1px solid #fed7aa;\n  background: #fff7ed;\n  color: #9a3412;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.employeedashboard-dyn-1 {\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: var(--employeedashboard-1-background);\n  color: var(--employeedashboard-1-color);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
